import { Box, Grid, IconButton, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from "formik";
import React from "react";
import { useQuery } from "react-query";
import { Link, useHistory } from "react-router-dom";

import { Async } from "../../../../components/Async";
import { Center } from "../../../../components/center";
import { DateInput } from "../../../../components/date_input";
import { SelectInput } from "../../../../components/select_input";
import { QUERY_KEYS } from "../../../../constants";
import { ROUTES } from "../../../../routes";
import { IClient } from "../../../client/data/entities";
import { ClientRepoImpl } from "../../../client/data/repo";
import { IExpense } from "../../../expense/data/entities";
import { ExpenseRepoImpl } from "../../../expense/data/repo";
import { IProduct } from "../../../product/data/entities";
import { ProductRepoImpl } from "../../../product/data/repo";
import { filterToQueryParams, ITransactionFilter, queryParamsToFilter } from "../../data/filter";
import { ITransactionType, transactionTypeOptions } from "../../data/models";

interface IProps {}

const todayDate = new Date();
export const initialFilter: ITransactionFilter = {
  createdDateRange: {
    from: todayDate,
    to: todayDate,
  },
  clientId: "",
  productId: "",
  expenseId: "",
  type: "",
};

export const TransactionFilter: React.FC<IProps> = () => {
  const asyncProductList = useQuery(QUERY_KEYS.productList, () => ProductRepoImpl.getList());
  const asyncClientList = useQuery(QUERY_KEYS.clientList, () => ClientRepoImpl.getList());
  const asyncExpenseList = useQuery(QUERY_KEYS.expenseList, () => ExpenseRepoImpl.getList());
  const history = useHistory();

  function onSubmit(values: ITransactionFilter) {
    history.push({
      search: filterToQueryParams(values),
    });
  }

  const initialValues = history.location.search ? queryParamsToFilter(history.location.search) : initialFilter;

  return (
    <Formik<ITransactionFilter> initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
      {({ values, submitForm, setFieldValue }) => {
        return (
          <Paper>
            <Box px={2}>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item sm={2}>
                  <DateInput
                    label="Tarixdən"
                    name="createdDateRange.from"
                    maxDate={values.createdDateRange?.to}
                    onChange={() => {
                      submitForm();
                    }}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                <Grid item sm={2}>
                  <DateInput
                    label="Tarixə"
                    name="createdDateRange.to"
                    minDate={values.createdDateRange?.from}
                    maxDate={todayDate}
                    onChange={() => {
                      submitForm();
                    }}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                <Grid item sm={2}>
                  <SelectInput<ITransactionType>
                    value={values.type}
                    options={[
                      {
                        id: "",
                        label: "Hamisi",
                      },
                      ...transactionTypeOptions,
                    ]}
                    name="type"
                    label="Əməliyyat tipi"
                    renderLabel={(a) => a.label}
                    onChange={() => {
                      submitForm();
                    }}
                  />
                </Grid>

                <Grid item sm={2}>
                  <Async
                    asyncData={asyncClientList}
                    renderSuccess={(clientList) => (
                      <SelectInput<IClient>
                        value={values.clientId}
                        options={clientList}
                        name="clientId"
                        label="Klient"
                        renderLabel={(a) => a.name}
                        onChange={() => {
                          submitForm();
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item sm={2}>
                  <Async
                    asyncData={asyncProductList}
                    renderSuccess={(productList) => (
                      <SelectInput<IProduct>
                        value={values.productId}
                        options={productList}
                        name="productId"
                        label="Mal"
                        renderLabel={(a) => a.name}
                        onChange={() => {
                          submitForm();
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item sm={2}>
                  <Async
                    asyncData={asyncExpenseList}
                    renderSuccess={(expenseList) => (
                      <SelectInput<IExpense>
                        value={values.expenseId}
                        options={expenseList}
                        name="expenseId"
                        label="Xərc"
                        renderLabel={(a) => a.name}
                        onChange={() => {
                          submitForm();
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item sm={1}></Grid>
              </Grid>

              <Grid container spacing={2} alignItems="flex-end" justify="flex-end">
                <Grid item sm={1}>
                  <Center>
                    <IconButton to={ROUTES.transaction} component={Link}>
                      <CloseIcon />
                    </IconButton>
                  </Center>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        );
      }}
    </Formik>
  );
};
